import merge from 'deepmerge'

import widgets_v1 from './widgets_v1'

type Wv1 = typeof widgets_v1

type Export = Wv1

export default merge.all([widgets_v1]) as Export
